/**
 * Frontend half of the `age_basis` vocabulary.
 *
 * The backend owns these values in
 * `backend/app/queries/base_score_details_keys.py` (`AGE_BASIS_TOPIC` /
 * `AGE_BASIS_ARTICLE`): whether a score blob's temporal fields were derived
 * from the topic cluster's earliest member or the article's own timestamps.
 * The union used to be spelled inline in `types.ts`, and ScoreBreakdownModal
 * branched on the bare `'topic'` literal to word its time-decay row. This
 * module owns the vocabulary and that wording;
 * `backend/tests/test_mirror_parity.py` pins the two stacks together.
 */
export const AGE_BASES = ['topic', 'article'] as const;

export type AgeBasis = (typeof AGE_BASES)[number];

/**
 * The parenthetical on the score breakdown's time-decay row. A topic-based
 * age is the story's (the cluster's earliest member set the clock), so it
 * says "story"; an article-based age — or a blob from before the field
 * existed — is the article's own.
 */
export function timeDecayAgeLabel(
  basis: AgeBasis | undefined,
  hoursText: string,
): string {
  return basis === 'topic' ? `story ${hoursText}h old` : `${hoursText}h old`;
}
